module.exports = __webpack_public_path__ + "static/media/camp1and2.f7eaed5d.gif";